import { render, staticRenderFns } from "./EnrollOrganization.vue?vue&type=template&id=30021165"
import script from "./EnrollOrganization.vue?vue&type=script&lang=js"
export * from "./EnrollOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports